import { render, staticRenderFns } from "./PrivilegeTable.vue?vue&type=template&id=5bfb4c1f&scoped=true&"
import script from "./PrivilegeTable.vue?vue&type=script&lang=js&"
export * from "./PrivilegeTable.vue?vue&type=script&lang=js&"
import style1 from "./PrivilegeTable.vue?vue&type=style&index=1&id=5bfb4c1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb4c1f",
  null
  
)

export default component.exports